import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { invalidateAutomationStepQueries } from '../../invalidateAutomationStepQueries';

export function useUpdateAutomationStepDueDateMutation({
	impersonationContext,
	onSuccess,
	onError,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onSuccess?: (data: Api.IAutomation) => void;
	onError?: (error: Api.IOperationResultNoValue, variables: { stepStatusId: string; dueDate: string }) => void;
}) {
	const userSession = useUserSession();

	return useMutation({
		onSuccess: data => {
			invalidateAutomationStepQueries();
			onSuccess?.(data);
		},
		onError,
		mutationFn: ({ stepStatusId, dueDate }: { stepStatusId: string; dueDate: string }) => {
			return userSession.webServiceHelper.callAsync<Api.IAutomation>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `Automation/Step/${encodeURIComponent(stepStatusId)}/DueDate`,
					queryParams: { dueDate },
				}),
				'PUT',
				null
			);
		},
	});
}
